/* eslint-disable no-console */
import Gikam from '../core/gikam-core.js';
import window from './template/window';
import Base from './base.js';
import Vue from 'vue';
import jQuery from 'jquery';

let defaultOptions = {
    renderTo: void 0,
    //页面大标题
    title: void 0,
    //定义子标题
    subTitle: null,
    //纪录缓存的window标识
    objectId: void 0,
    //是否显示标题，默认显示
    showTitle: true,
    //标题后的按钮位置，可选配置为'left','center','right'(默认)
    toolbarAlign: 'right',
    //标题及按钮工具栏显示在顶部
    toolbarTop: true
};

export default class Window extends Base {

    static windowManager = {};

    static rememberWindow(window) {
        if (!window.options.objectId) {
            return;
        }
        let fragment = document.createDocumentFragment();
        fragment.appendChild(window.model.$el);
        Window.windowManager[window.options.objectId] = fragment;
    }

    constructor(param) {
        super();
        this.history = [];
        this.historyViewModel = [];
        this.fragment = document.createDocumentFragment();
        this.activeUrl = void 0;
        //窗口是否只读
        this.readonly = false;
        //获取菜单url参数
        this.$param = {};
        //所有组件
        this.$compStore = {};
        //根组件
        this.$window = this;
        //页面id
        this.$pageId = null;
        this.initialize(param, defaultOptions).init();
    }

    changeSubTitle(text) {
        text && (this.options.subTitle = text);
    }

    createModel() {
        let _this = this;
        return new Vue({
            el: Gikam.createDom('div', this.options.renderTo),
            components: { window },
            data() {
                return {
                    options: _this.options
                };
            },
            render() {
                return <window ref="vm" options={this.options}></window>;
            }
        });
    }

    //显示数据加载中遮罩
    showMask() {
        this.model.$children[0].dataLoading = true;
    }

    //关闭数据加载中遮罩
    closeMask() {
        this.model.$children[0].dataLoading = false;
    }

    showPageMask() {
        this.model.$refs.vm.pageLoading = true;
    }

    closePageMask() {
        this.model.$refs.vm.pageLoading = false;
    }

    clean() {
        let toolbar = this.model.$el.querySelector('.toolbar');
        let body = this.model.$el.querySelector('.body');
        if (toolbar) {
            toolbar.innerHTML = '';
        }
        if (body) {
            body.innerHTML = '';
        }
    }

    rememberWindow() {
        this.model.$el.$pageId = this.$pageId;
        this.fragment.appendChild(this.model.$el);
        this.historyViewModel.push(this.model);
        this.init();
    }

    load(url) {
        let _this = this;
        this.$cleanStoreComp();
        this.history.push(url);
        this.rememberWindow();
        this.showPageMask();
        this.$param = Gikam.getRequestParam(url);
        if (Gikam.isTrue(this.$param.readonly)) {
            this.readonly = true;
        }
        Gikam.getText(url).done(r => {
            this.$pageId = this.getPageId(url);
            eval(r.trim().replace(/<script>|<\/script>|\r|\n/g, ''));
        }).fail(function () {
            jQuery(_this.model.$el).children('.window-error-container').html(Gikam.propI18N('GIKAM.TIP.PAGE_NOT_EXISTS'));
        }).always(() => {
            _this.closePageMask();
        });
    }
    

    /**
     * @description 将url作为页面id
     * @private
     * @param {String} url请求地址
     * @memberof Window
     */
    getPageId(url) {
        return url ? url.replace(/\?[\s\S]+/g, '') : null;
    }

    goBack() {
        const def = jQuery.Deferred();
        this.showPageMask();
        this.history.pop();
        this.destroy();
        const lastViewModel = this.historyViewModel.pop();
        this.options.renderTo.appendChild(lastViewModel.$el);
        this.model = lastViewModel;
        const storage = this.model.storage;
        if (storage && storage.grid) {
            storage.grid.refreshRowByIndex(storage.index, storage.scroll);
            this.model.storage = null;
        } else {
            this.model.$el.querySelectorAll('.grid').forEach(dom => {
                Gikam.getInstance(dom).refresh();
            });
        }
        this.closePageMask();
        this.$pageId = this.model.$el.$pageId;
        return def.resolve();
    }

    removeTitle() {
        this.options.showTitle = false;
        return this;
    }

    setToolbarAlign(align) {
        this.options.toolbarAlign = align;
        return this;
    }

    save(param) {
        let dataList = [null],
            _this = this,
            def = jQuery.Deferred(),
            mainForm = Gikam.getInstance(jQuery(_this.$dom).find('.form:first'));
        if (!param.url) {
            console.error('url not exists');

        }
        if (!param.page.setCompUrl) {
            console.error('do not find updateCompUrl method');
        }
        let $comps = jQuery(this.$dom).find('.form,.grid,.simple-grid'),
            validateResult = true;
        $comps.each(function () {
            let comp = Gikam.getInstance(jQuery(this)),
                compData = [],
                d = comp.getData();
            if (comp.validate() === false) {
                validateResult = false;
                return false;
            }
            if (Gikam.isEmpty(comp.options.service)) {
                return true;
            }
            compData.push(comp.options.service);
            compData.push(Array.isArray(d) ? d : [d]);
            dataList.push(compData);
        });
        if (validateResult === false) {
            this.closeMask();
            return def;
        }
        this.showMask();
        Gikam[Gikam.isEmpty(param.page.param.id) ? 'postText' : 'put'](param.url, Gikam.getJsonWrapper.apply(Gikam, dataList)).done(function (id) {
            if (Gikam.isNotEmpty(param.page.param.id)) {
                def.resolve();
                return;
            }
            mainForm.toFieldsReadonly(['id']);
            param.page.param.id = arguments[0];
            param.page.setCompUrl.call(param.page);
            let async = [];
            $comps.each(function () {
                let comp = Gikam.getInstance(this);
                comp.getOptions().service && async.push(comp.refresh());
            });
            jQuery.when.apply(jQuery, async).done(function () {
                def.resolve(id);
            });
        }).always(function () {
            _this.closeMask();
        });
        return def;
    }

    destroy() {
        jQuery(this.model.$el).remove();
        this.model.$destroy();
        if (Window.windowManager[this.options.objectId]) {
            delete Window.windowManager[this.options.objectId];
        }
    }

    setDefaultOptions(options) {
        Gikam.extend(true, defaultOptions, options.defaultOptions);
    }

    showHeader() {
        this.model.$refs.vm.headerShow = true;
    }

    /**
     * @description 注册window下所有组件
     * @private 
     * @param {String} type 组件类型
     * @param {*} comp 组件对象
     * @memberof Window
     */
    $addStoreComp(type, comp) {
        if (!this.$compStore[type]) {
            this.$compStore[type] = [];
        }
        this.$compStore[type].push(comp);
    }

    /**
     * @description 清空window下所有组件
     * @private
     * @memberof Window
     */
    $cleanStoreComp() {
        this.$compStore = {};
    }

    init() {
        this.model = this.createModel();
        this.$dom = this.model.$refs.vm.$refs.body;
        this.$toolbar = this.model.$refs.vm.$refs.toolbar;
        this.bindInstance(this.model.$el);
        this.bindInstance(this.$dom);
    }

}